
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = []
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "1a92169f03677d80f8a9.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			